export var createGetOrCreateBackupOfflineAudioContext = function createGetOrCreateBackupOfflineAudioContext(backupOfflineAudioContextStore, nativeOfflineAudioContextConstructor) {
  return function (nativeContext) {
    var backupOfflineAudioContext = backupOfflineAudioContextStore.get(nativeContext);

    if (backupOfflineAudioContext !== undefined) {
      return backupOfflineAudioContext;
    }

    if (nativeOfflineAudioContextConstructor === null) {
      throw new Error('Missing the native OfflineAudioContext constructor.');
    }

    backupOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 8000);
    backupOfflineAudioContextStore.set(nativeContext, backupOfflineAudioContext);
    return backupOfflineAudioContext;
  };
};